export default "__VITE_ASSET__D2MTC7xZ__"